// extracted by mini-css-extract-plugin
module.exports = {"link":"_ec169472","item":"_8fb84a27","image":"_f778f915","title":"_384022d2"};